import { Store } from 'redux';
import { EpiAppState } from '../../Shared/Scripts/Store/Types';
import { updateEpiModel } from '../../Shared/Scripts/Store/EpiContext/Actions'; 
import { getDateNow } from '../../Shared/Scripts/Utilities/DateResolver';
import { epiResolveLanguage } from '../../Shared/Scripts/Utilities/EpiResolveLanguage';

export default function InitEpiContent<T>(store: Store<EpiAppState<T>>, contentLink: string): void {
    const timeOfCall = getDateNow();

    window.addEventListener('load', () => {
        getContentByContentLink<T>(contentLink)
        .then((data) => {
            store.dispatch(updateEpiModel(data, timeOfCall, false));
        })
        .catch(() => {
            store.dispatch(updateEpiModel(null, timeOfCall, true));
        });
    });
}

const getContentByContentLink = async <T>(contentLink: string): Promise<T> => {
    const url = new URL('/api/veiledersteg', window.location.origin);
    url.searchParams.append('currentPage', contentLink);
    url.searchParams.append('culture', epiResolveLanguage());

    const response = await fetch(url);

    if (!response.ok) {
        throw response;
    }

    return await response.json();
}
